/**
 * allocationsApi.js — Phase 86.D. Purpose tags + goal allocations.
 */
import axios from 'axios';
import { supabase } from '@/lib/supabaseClient';

const API = process.env.REACT_APP_BACKEND_URL;

export const PURPOSE_OPTIONS = [
  { value: 'everyday',     label: 'Everyday spending' },
  { value: 'emergency',    label: 'Emergency reserve' },
  { value: 'bills',        label: 'Bills' },
  { value: 'goal_funding', label: 'Goal funding' },
  { value: 'income',       label: 'Income account' },
  { value: 'other',        label: 'Other' },
];

export const ALLOCATION_METHODS = [
  { value: 'entire_resource', label: 'All of it' },
  { value: 'fixed_amount',    label: 'A fixed amount' },
  { value: 'percentage',      label: 'A percentage' },
];

async function headers() {
  let { data: { session } } = await supabase.auth.getSession();
  if (!session?.access_token) {
    await new Promise((r) => setTimeout(r, 700));
    ({ data: { session } } = await supabase.auth.getSession());
  }
  const t = session?.access_token;
  return t ? { Authorization: `Bearer ${t}` } : {};
}

async function get(path) {
  for (const attempt of [1, 2]) {
    try {
      const r = await axios.get(`${API}${path}`, { headers: await headers(), timeout: 25000 });
      return r.data;
    } catch (e) {
      if (attempt === 2) {
        console.warn('allocations GET failed:', path, e?.response?.status || e?.message);
        return null;
      }
      await new Promise((r) => setTimeout(r, 900));
    }
  }
  return null;
}

export const fetchMoneyPurpose      = () => get('/api/money-purpose');
export const fetchGoalAllocations   = () => get('/api/goal-allocations');
export const fetchAllocationResources = () => get('/api/allocations/resources');

/** Returns { ok } or { ok:false, migrationPending, error }. */
export async function setAccountPurpose(accountId, purpose) {
  try {
    const r = await axios.patch(`${API}/api/accounts/${accountId}/purpose`,
      { purpose }, { headers: await headers(), timeout: 20000 });
    return { ok: true, data: r.data };
  } catch (e) {
    const detail = e?.response?.data?.detail;
    return {
      ok: false,
      migrationPending: e?.response?.status === 503
        || detail?.error === 'purpose_migration_pending',
      error: detail?.detail || detail?.error || e?.message,
    };
  }
}

export async function replaceGoalAllocations(goalId, allocations) {
  try {
    const r = await axios.put(`${API}/api/goal-allocations/${goalId}`,
      { allocations }, { headers: await headers(), timeout: 20000 });
    return { ok: true, data: r.data };
  } catch (e) {
    const detail = e?.response?.data?.detail;
    return {
      ok: false,
      migrationPending: e?.response?.status === 503,
      error: detail?.detail || detail?.error || e?.message,
    };
  }
}
